var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { Point } from "pixi.js";
import * as React from "react";
import { connect } from "react-redux";
import { utilAnimation } from "../../utils/animation/utilAnimation";
import { utilTweenAnimation } from "../../utils/utilTweenAnimation";
import { actionRemoveRewardPelletsAnimation } from "../animation/actionPelletAnimations";
import { bugsnagClient } from "../bugsnag/bugsnagClient";
import { ErrorBoundary } from "../generic/ErrorBoundary";
import { List } from "../generic/list/List";
import { actionBuildingsDeselect } from "../player-base/buildings/actionBuildings";
import { ViewportWorldSpace } from "../viewport/ViewportWorldSpace";
import { RewardPelletGroup } from "./RewardPelletGroup";
var RewardPellets = /** @class */ (function (_super) {
    __extends(RewardPellets, _super);
    function RewardPellets() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.EndPointDistanceFromBuildingCenter = 40;
        _this.BezierPointDistanceFromBuildingCenter = 25;
        _this.BezierAngle = 70;
        _this.buildingIdRunningAnimation = {};
        _this.renderAnimations = function () {
            var rewardPellets = _this.props.rewardPellets;
            rewardPellets.forEach(function (rewardPellet) {
                var rewards = rewardPellet.rewards, origin = rewardPellet.origin, id = rewardPellet.id;
                var buildingCenter = _this.getCoordinatesCorrespondingToViewport(origin);
                var x = buildingCenter.x, y = buildingCenter.y;
                if (rewards.length > 0) {
                    var animations_1 = [];
                    var _a = utilTweenAnimation.getBezierCurvePoints(buildingCenter, rewards.length, _this.EndPointDistanceFromBuildingCenter, _this.BezierPointDistanceFromBuildingCenter, _this.BezierAngle), bezierPoints_1 = _a.bezierPoints, endPoints_1 = _a.endPoints;
                    rewards.forEach(function (reward, index) {
                        var rewardId = "#" + _this.getRewardId(reward, id, index);
                        var rewardBezierPoint = {
                            x: x - bezierPoints_1[index].x,
                            y: y - bezierPoints_1[index].y,
                        };
                        var rewardEndPoint = {
                            x: x - endPoints_1[index].x,
                            y: y - endPoints_1[index].y,
                        };
                        animations_1.push({
                            bezierPoint: rewardBezierPoint,
                            buildingId: id,
                            elementId: rewardId,
                            endPoint: rewardEndPoint,
                        });
                    });
                    _this.startAnimation(animations_1);
                }
            });
        };
        _this.renderRewardPellets = function (viewport) {
            var rewardPellets = _this.props.rewardPellets;
            _this.viewport = viewport;
            var rewardPelletGroups = rewardPellets.map(function (rewardPellet) {
                var rewards = rewardPellet.rewards, id = rewardPellet.id, origin = rewardPellet.origin;
                var rewardPelletItems = [];
                var buildingCenter = _this.getCoordinatesCorrespondingToViewport({
                    x: origin.x - 50,
                    y: origin.y - 130,
                });
                var x = buildingCenter.x, y = buildingCenter.y;
                var menuStyle = {
                    left: x + "px",
                    position: "absolute",
                    top: y + "px",
                };
                rewards.forEach(function (reward, index) {
                    var rewardId = _this.getRewardId(reward, id, index);
                    rewardPelletItems.push(__assign({}, reward, { id: rewardId }));
                });
                return {
                    item: rewardPelletItems,
                    style: menuStyle,
                };
            });
            return React.createElement(List, { items: rewardPelletGroups, renderItem: _this.renderRewardPelletGroup });
        };
        _this.renderRewardPelletGroup = function (rewardPelletGroupInfo, index) {
            var item = rewardPelletGroupInfo.item, style = rewardPelletGroupInfo.style;
            return (React.createElement("div", { key: index, style: style },
                React.createElement(RewardPelletGroup, { items: item })));
        };
        _this.startAnimation = function (animations) {
            var removeRewardPelletsAnimation = _this.props.removeRewardPelletsAnimation;
            animations.forEach(function (animationInfo) {
                var buildingId = animationInfo.buildingId, elementId = animationInfo.elementId;
                var animationInstance = utilAnimation.startRewardPelletAnimation(animationInfo, function (animatedElementId) {
                    _this.buildingIdRunningAnimation[animatedElementId].kill();
                    delete _this.buildingIdRunningAnimation[animatedElementId];
                    removeRewardPelletsAnimation(buildingId);
                });
                // Check if animation was running
                var isAnimationActive = _this.buildingIdRunningAnimation.hasOwnProperty(elementId);
                if (isAnimationActive) {
                    var animationProgress = _this.buildingIdRunningAnimation[elementId].progress();
                    _this.buildingIdRunningAnimation[elementId].kill();
                    animationInstance.progress(animationProgress);
                }
                _this.buildingIdRunningAnimation[elementId] = animationInstance;
            });
        };
        _this.getRewardId = function (reward, id, index) {
            return "rewardItem" + id + reward.icon + reward.amount.toString() + index.toString();
        };
        _this.getCoordinatesCorrespondingToViewport = function (origin) {
            return _this.viewport.toGlobal(new Point(origin.x, origin.y));
        };
        return _this;
    }
    RewardPellets.prototype.componentWillUnmount = function () {
        this.buildingIdRunningAnimation = {};
        this.props.onDeselect();
    };
    RewardPellets.prototype.render = function () {
        var arePelletsAvailable = this.props.rewardPellets && this.props.rewardPellets.length === 0;
        if (arePelletsAvailable) {
            return React.createElement(React.Fragment, null);
        }
        return (React.createElement(ErrorBoundary, { client: bugsnagClient.bugsnag, name: "RewardPelletsDOM.tsx" },
            React.createElement("div", { className: "reward-pellets-dom" },
                React.createElement(ViewportWorldSpace, { key: this.props.rewardPellets.length, componentDidUpdate: this.renderAnimations }, this.renderRewardPellets))));
    };
    return RewardPellets;
}(React.Component));
var mapState = function (state) {
    return {
        rewardPellets: state.animations.rewardPellets,
    };
};
var mapDispatch = function (dispatch) { return ({
    onDeselect: function () { return dispatch(actionBuildingsDeselect()); },
    removeRewardPelletsAnimation: function (id) { return dispatch(actionRemoveRewardPelletsAnimation(id)); },
}); };
export var RewardPelletsDOM = connect(mapState, mapDispatch)(RewardPellets);



//////////////////
// WEBPACK FOOTER
// ./src/features/reward-pellets/RewardPelletsDOM.tsx
// module id = 2320
// module chunks = 3